import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getChannel, getUserCreatedChannel } from "../../api/channels/channelServices";
import { getStatusHistory } from "../../api/artifacts/atrifactService";
import { SKContentStatusHistory } from "../../models/SKArtifact";
import { format } from "date-fns";
import { capitalizeFirstLetter } from "../../utils/stringFunctions";

const StatusHistory = () => {
  const { id } = useParams();

  const [statusList, setStatusList] = useState<SKContentStatusHistory[]>([]);

  useEffect(() => {
    const getHistory = async (id: string) => {
      const statusList = await getStatusHistory(id);
      setStatusList(statusList);
    };
    if (id) {
      getHistory(id);
    }
  }, [id]);

  return (
    <div className="flex flex-col gap-[10px] mt-[15px]">
      {statusList.map((item, index) => {
        return (
          <div key={index} className="relative w-full">
            <div className="flex flex-col w-full">
              <div>
                <p className="history-date">{item.createdDate ? format(item.createdDate.toDate(), "MMM, dd yyyy hh:mm a") : "--"}</p>
              </div>
              <div>
                <p className="history-status">{capitalizeFirstLetter(item.status)}</p>
              </div>
              {item.status && (
                <div>
                  <p className="history-note-reasoncode">{item.reason}</p>
                </div>
              )}

              {item.note && (
                <div>
                  <p className="history-note-reasoncode">{item.note}</p>
                </div>
              )}
            </div>
            <div className="thinseparator mt-[10px]" />
          </div>
        );
      })}
    </div>
  );
};

export default StatusHistory;
